import { useRecoilState } from "recoil";
import {
  scannedDataAtom,
  foodItemsFromBackendAtom,
  uploadedImageAtom,
  documentIdAtom,
  ghiReasonsAtom,
  ghiScoreAtom,
  ghiLabelAtom,
  bbsScoreAtom,
  bbsLabelAtom,
  otherDetailsAtom,
  glucoseSpikeAtom,
} from "../store/foodManagementAtoms";

export const useFoodManagement = () => {
  const [scannedData, setScannedData] = useRecoilState(scannedDataAtom);
  const [foodItemsFromBackend, setFoodItemsFromBackend] = useRecoilState(foodItemsFromBackendAtom);
  const [uploadedImage, setUploadedImage] = useRecoilState(uploadedImageAtom);
  const [documentId, setDocumentIdRaw] = useRecoilState(documentIdAtom);
  const [ghiReasons, setGhiReasons] = useRecoilState(ghiReasonsAtom);
  const [ghiScore, setGhiScore] = useRecoilState(ghiScoreAtom);
  const [ghiLabel, setGhiLabel] = useRecoilState(ghiLabelAtom);
  const [bbsScore, setBbsScore] = useRecoilState(bbsScoreAtom);
  const [bbsLabel, setBbsLabel] = useRecoilState(bbsLabelAtom);
  const [otherDetails, setOtherDetails] = useRecoilState(otherDetailsAtom);
  const [glucoseSpikeData, setGlucoseSpikeData] = useRecoilState(glucoseSpikeAtom);

  const setDocumentId = (id: string | null) => {
    setDocumentIdRaw(id);
    if (id) {
      localStorage.setItem("glucera_document_id", id);
    } else {
      localStorage.removeItem("glucera_document_id");
    }
  };

  return {
    scannedData,
    setScannedData,
    foodItemsFromBackend,
    setFoodItemsFromBackend,
    uploadedImage,
    setUploadedImage,
    documentId,
    setDocumentId,
    ghiReasons,
    setGhiReasons,
    ghiScore,
    setGhiScore,
    ghiLabel,
    setGhiLabel,
    bbsScore,
    setBbsScore,
    bbsLabel,
    setBbsLabel,
    otherDetails,
    setOtherDetails,
    glucoseSpikeData,
    setGlucoseSpikeData,
  };
};
